



$(function () {

    var tileCalculator = {

        waste: false,
        wastePercentage: 10,

        product: {
            width: 0,
            length: 0,
            per_pack: 0,
            price: 0,
            price_each: 0,
            price_sqm: "0.00"
        },

        qty: 0,
lastSqm: 0,
userSqmLocked: false, // 🔒 tracks if user entered sqm


        init: function () {

            this.qty = 0;
            this.lastSqm = 0;

            $('#productQty').val('0');
            $('#productPriceTotal').text('0');

            var self = this;

            $('#productMetresSq')
                .val('0.00')
                .on('focus', function () {
                    if (this.value === '0.00') {
                        this.value = '';
                    }
                })
                .on('blur', function () {
                    // ✅ UI ONLY — do NOT touch calculator state
                    if (this.value.trim() === '') {
                        this.value = '0.00';
                    }
                });

            this.update();
            this.listeners();
        },


        /* -------------------------
           PRODUCT / VARIANT UPDATE
        -------------------------- */
     update: function () {

    var $inputs = $('.tileSize input[type=radio]');
    if (!$inputs.length) return;

    var $input = $inputs.filter(':checked').last();

    // 🔒 fallback: force select last available option
    if (!$input.length) {
        $input = $inputs.last().prop('checked', true);
    }

    this.product.width = Number($input.data('width')) || 0;
    this.product.length = Number($input.data('length')) || 0;
    this.product.per_pack = Number($input.data('per-pack')) || 0;
   this.product.price = parseFloat(
  String($input.data('price')).replace(/,/g, '')
) || 0;


    if (!this.product.width || !this.product.length || !this.product.per_pack) {
        return;
    }

    this.product.price_each =
        this.product.price / this.product.per_pack;

    this.product.price_sqm = this.pricePerSqm();
    $('.productPerSqm').text(this.product.price_sqm);
    $('#pdp_price').text(this.product.price_sqm);
    
    

    if (this.lastSqm > 0) {
        this.qty = this.packs(this.lastSqm);
        $('#productQty').val(this.qty);
        this.updatePrice();
    }
},


       listeners: function () {
  var self = this;

  // Variant changed (theme event)
document.addEventListener('variant:change', function () {

  var preservedQty = tileCalculator.qty;      // ✅ keep packs
  var preservedWaste = tileCalculator.waste;  // ✅ keep wastage

  setTimeout(function () {

    // Update variant (new width/length/price)
    tileCalculator.update();

    // Restore wastage
    tileCalculator.waste = preservedWaste;
    $('#productWaste').prop('checked', preservedWaste);

    // 🔁 Recalculate AREA from QTY
// 🔁 Recalculate AREA from QTY
if (preservedQty && preservedQty > 0) {

    tileCalculator.qty = preservedQty;
    $('#productQty').val(preservedQty);

    // ✅ sqm per pack
    var sqmPerPack =
        (tileCalculator.product.width *
         tileCalculator.product.length *
         tileCalculator.product.per_pack) / 10000;

    // ✅ BASE sqm ONLY (no wastage here)
   // sqm covered by quantity (this INCLUDES wastage)
var rawSqm = preservedQty * sqmPerPack;

// 🔒 BASE sqm (reverse wastage if enabled)
var baseSqm = rawSqm;

if (tileCalculator.waste) {
    baseSqm = rawSqm / (1 + tileCalculator.wastePercentage / 100);
}

// store BASE sqm only
tileCalculator.lastSqm = baseSqm;
tileCalculator.userSqmLocked = false;

// Area Needed (BASE)
$('#productMetresSq').val(
    tileCalculator.getFlooredFixed(baseSqm, 2)
);

// Total Area (BASE + wastage)
tileCalculator.updateTotalAreaDisplay();

// Price
tileCalculator.updatePrice();


    tileCalculator.lastSqm = baseSqm;
    tileCalculator.userSqmLocked = false;

    // Area Needed (base)
    $('#productMetresSq').val(
        tileCalculator.getFlooredFixed(baseSqm, 2)
    );

    // Total Area (incl. wastage)
    tileCalculator.updateTotalAreaDisplay();

    // Price
    tileCalculator.updatePrice();



    }

  }, 0);
});



  // ✅ Delegated (works after rerender)
  $(document).on('change', '.tileSize input[type=radio]', function () {
    self.update();
  });

$(document).on('change', '#productMetresSq', function () {
    self.sqmCalc();
});


  $(document).on('keyup change', '#productQty', function () {
    self.qtyCalc();
  });

  $(document).on('change', '#productWaste', function (e) {
    self.wasteCalc(e);
  });

  // Optional: keep your UI focus/blur behavior (delegated)
  $(document)
    .off('focus.tileCalc blur.tileCalc', '#productMetresSq')
    .on('focus.tileCalc', '#productMetresSq', function () {
      if (this.value === '0.00') this.value = '';
    })
    .on('blur.tileCalc', '#productMetresSq', function () {
      if (this.value.trim() === '') this.value = '0.00';
    });
},


        /* -------------------------
           SQM → QTY → PRICE
        -------------------------- */
    sqmCalc: function () {

    this.update();

    if (!this.product.width || !this.product.length || !this.product.per_pack) {
        return;
    }

    var sqm = parseFloat($('#productMetresSq').val());

    if (isNaN(sqm) || sqm <= 0) {
        this.reset();
        return;
    }

    this.userSqmLocked = true; // 🔒 lock area forever
this.lastSqm = sqm;

this.qty = this.packs(sqm);
$('#productQty').val(this.qty);

this.updateTotalAreaDisplay();
this.updatePrice();

},



        /* -------------------------
           QTY → SQM → PRICE
        -------------------------- */
       qtyCalc: function () {

    var qty = parseInt($('#productQty').val(), 10);

    if (isNaN(qty) || qty <= 0) {
        this.reset();
        return;
    }

    this.qty = qty;

    // ❌ NEVER recalc sqm
    // sqm is user-owned

    this.updatePrice();
},

        /* -------------------------
           WASTE TOGGLE
        -------------------------- */
        wasteCalc: function (e) {

            this.waste = e.target.checked ? this.wastePercentage : false;
            
            if (this.lastSqm > 0) {
                this.qty = this.packs(this.lastSqm);
                $('#productQty').val(this.qty);
                this.updateTotalAreaDisplay();
                this.updatePrice();

            }
        },

        packs: function (sqm) {

            var tilesPerSqm = 10000 / (this.product.width * this.product.length);
            var tilesRequired = tilesPerSqm * sqm;

            if (this.waste) {
                tilesRequired += (tilesRequired * this.wastePercentage) / 100;
            }

            return Math.ceil(tilesRequired / this.product.per_pack);
        },

        pricePerSqm: function () {

            if (!this.product.width || !this.product.length) return "0.00";

            var sqm = 10000 / (this.product.width * this.product.length);
            return this.getFlooredFixed(sqm * this.product.price_each, 2);
        },

        coveragePerBox: function () {

    if (
        !this.product.width ||
        !this.product.length ||
        !this.product.per_pack
    ) {
        return 0;
    }

    // tile area (m²)
    var tileArea =
        (this.product.width * this.product.length) / 10000;

    // coverage per box (m²)
    return tileArea * this.product.per_pack;
},

updateTotalAreaDisplay: function () {

    if (this.qty <= 0) {
        $('#tileTotalArea').text('0.00');
        return;
    }

    var coveragePerBox = this.coveragePerBox();
    var totalCoverage = this.qty * coveragePerBox;

    $('#tileTotalArea').text(
        this.getFlooredFixed(totalCoverage, 2)
    );
},



        updatePrice: function () {

            var total = this.product.price * this.qty;
            $('#productPriceTotal').text(this.getFlooredFixed(total, 2));
        },

        reset: function () {
    this.qty = 0;
    this.lastSqm = 0;
    this.userSqmLocked = false; // 🔓 unlock

    $('#productQty').val('0');
    $('#productMetresSq').val('0.00');
    $('#productPriceTotal').text('0');
     // ✅ FIX: reset total coverage UI
    $('#tileTotalArea').text('0.00');
},

        getFlooredFixed: function (v, d) {
            return (
                Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)
            ).toFixed(d);
        }
    };

    tileCalculator.init();
});